
<script>
    export default {
        template: `<div>
  <span  v-for="tag , index in value" class="tag-list" style="margin: 5px">
    {{tag.name}}
    <button class="delete is-small close-but" @click="remove(index,tag)">

    </button>
  </span>
</div>`,
        props: ['value'],
        methods: {
            remove (index,tag) {
                var clonedValue = this.value.slice()
                clonedValue.splice(index, 1)
                this.$emit('input', clonedValue)
                this.$emit('detach',tag)
            }
        }
    }

</script>
<style scoped>
    .tag-list{
        margin-right: 2px;
        background-color: #0095ff;
        color: white;
        padding: 6px;
        border: 0;
        float: left;
        border-radius: 10px;
    }
    .close-but{
        background-color: #ff464a;
        border: 0;
        height: 10px;
        border-radius: 21px;
        padding: 2px 6px;
    }
</style>
